import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import LocalizedText from '@LocalizedText';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Popup.scss';

import Button from '@components/buttons/Button';
import DefaultButton from '@components/buttons/default-btn/DefaultButton';

const Popup = ({
  className,
  children,
  onClose,
  onConfirm,
  closePopup,
  intlValues,
  titleLocKey,
  closeLocKey,
  confirmLocKey,
  closeOnOutsideClick = false,
  ...props
}) => {
  const popupContainer = document.getElementById('qau-popup-container');
  const popupNode = document.createElement('div');

  const onCloseHandler = useCallback(() => {
    closePopup();
    onClose && onClose();
  }, [closePopup, onClose]);

  const onConfirmHandler = () => {
    closePopup();
    onConfirm && onConfirm();
  };

  useEffect(() => {
    const onOuterClick = e => {
      e.target === popupContainer && closeOnOutsideClick && onCloseHandler();
    };
    popupContainer.appendChild(popupNode);
    popupContainer.setAttribute('class', 'active');
    popupContainer.addEventListener('click', onOuterClick);
    return () => {
      popupContainer.removeChild(popupNode);
      popupContainer.removeAttribute('class');
      popupContainer.removeEventListener('click', onOuterClick);
    };
  }, [popupContainer, popupNode, closeOnOutsideClick, onCloseHandler]);

  return createPortal(
    <div className="qau-popup-wrapper">
      <div className={classnames('qau-popup', className)}>
        <div className="popup-header">
          <span className="title">
            <LocalizedText id={titleLocKey} values={intlValues} />
          </span>
          <Button className="header-close-btn" onClick={onCloseHandler} />
        </div>
        <div className="popup-content">{children}</div>
        <div className="popup-footer">
          <DefaultButton className="footer-close-btn" onClick={onCloseHandler} locKey={closeLocKey} secondary={!!onConfirm} />
          {onConfirm && <DefaultButton className="footer-confirm-btn" onClick={onConfirmHandler} locKey={confirmLocKey} />}
        </div>
      </div>
    </div>,
    popupContainer,
  );
};

Popup.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  onConfirm: PropTypes.func,
  className: PropTypes.string,
  closeLocKey: PropTypes.string,
  confirmLocKey: PropTypes.string,
  intlValues: PropTypes.object,
  closeOnOutsideClick: PropTypes.bool,
  closePopup: PropTypes.func.isRequired,
  titleLocKey: PropTypes.string.isRequired,
};

export default Popup;
